import Grid2 from "@mui/material/Grid2";
import { Tooltip, Typography } from "components";
import PieChart from "components/Highcharts/PieChart";

interface PieChartSectionProps {
  pieData: any;
  pieClickData: any;
  pieHoverData: any;
  setPieClickData: any;
  setPieHoverData: any;
  pieRef: any;
  title: string;
}

const PieChartSection = (props: PieChartSectionProps) => {
  const {
    pieData,
    pieClickData,
    pieHoverData,
    setPieClickData,
    setPieHoverData,
    pieRef,
    title,
  } = props;

  return (
    <Grid2 container flexDirection="column" alignItems="center">
      <Grid2 display="flex" justifyContent="center" alignItems="center" mb={2}>
        <PieChart
          data={pieData}
          pieClickData={pieClickData}
          onClick={setPieClickData}
          onHover={setPieHoverData}
          title={title}
        />
      </Grid2>

      {/* Title */}
      {/* <Typography fontWeight={500} color="var(--black)" fontSize={16} mb={1}>
        title
      </Typography> */}

      {/* Legends */}
      <div
        style={{
          width: "70%",
          maxHeight: 300,
          overflow: "auto",
        }}
      >
        {pieData?.map((legends: any) => (
          <Grid2
            container
            key={legends.id}
            alignItems="center"
            justifyContent="space-between"
            style={{
              fontWeight: 600,
              borderRadius: "4px",
              padding: "6px 8px",
              backgroundColor:
                pieClickData?.id === legends.id
                  ? "var(--neutral-100)"
                  : "transparent",
              color:
                pieHoverData?.id === legends.id
                  ? "var(--primary-500)"
                  : "var(--neutral-500)",
            }}
          >
            <Grid2 size={9} display="flex" alignItems="center" gap={1}>
              <div
                style={{
                  width: 12,
                  height: 12,
                  borderRadius: 2,
                  backgroundColor: legends.color,
                }}
              />

              <Tooltip title={legends.id} arrow placement="top">
                <Typography
                  fontSize={12}
                  fontWeight={600}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  width="100%"
                  style={{ cursor: "pointer" }}
                  onClick={() => setPieClickData(legends)}
                  ref={pieHoverData?.id === legends.id ? pieRef : undefined}
                >
                  {legends.id}
                </Typography>
              </Tooltip>
            </Grid2>

            <Grid2 size={3} textAlign="right">
              <Typography fontSize={12} fontWeight={600} color="var(--black)">
                {legends.value.toFixed(2)}%
              </Typography>
            </Grid2>
          </Grid2>
        ))}
      </div>
    </Grid2>
  );
};

export default PieChartSection;
